import { render, staticRenderFns } from "./FilterItem2.vue?vue&type=template&id=5e2f174b&scoped=true&"
import script from "./FilterItem2.vue?vue&type=script&lang=js&"
export * from "./FilterItem2.vue?vue&type=script&lang=js&"
import style0 from "./FilterItem2.vue?vue&type=style&index=0&id=5e2f174b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f174b",
  null
  
)

export default component.exports